var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeFileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9993 14.125C17.8327 15 17.1243 15.6667 16.2493 15.7917C14.8743 16 12.5827 16.25 9.99935 16.25C7.45768 16.25 5.16602 16 3.74935 15.7917C2.87435 15.6667 2.16602 15 1.99935 14.125C1.83268 13.1667 1.66602 11.75 1.66602 10C1.66602 8.25 1.83268 6.83333 1.99935 5.875C2.16602 5 2.87435 4.33333 3.74935 4.20833C5.12435 4 7.41602 3.75 9.99935 3.75C12.5827 3.75 14.8327 4 16.2493 4.20833C17.1243 4.33333 17.8327 5 17.9993 5.875C18.166 6.83333 18.3743 8.25 18.3743 10C18.3327 11.75 18.166 13.1667 17.9993 14.125Z",
    fill: "#DB0011"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 12.9163V7.08301L13.334 9.99967L8.33398 12.9163Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeFileLogo);
export default __webpack_public_path__ + "static/media/youtubeFile_logo.7eafceccd282322e3c4163f6320ffcde.svg";
export { ForwardRef as ReactComponent };